import { render, staticRenderFns } from "./AlertBannerRecords.vue?vue&type=template&id=9216a4de&scoped=true&"
import script from "./AlertBannerRecords.vue?vue&type=script&lang=js&"
export * from "./AlertBannerRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9216a4de",
  null
  
)

export default component.exports